import axios from "axios";
import { handleApiError } from "./handleApiError";
import { apiUrl } from "./axiosConfig";
import {   coreapiUrl } from "./applicationService/appinstance";
 
const authService = {
  checkuserexist: async (payload) => {
    try {
      const response = await axios.post(
        `${coreapiUrl}/checkuserexist`,
        payload
      );
      return response.data; 
    } catch (error) {
      return handleApiError(error);  
    }
  },
 
  loginapi: async (payload) => {
    try {
      const response = await axios.post(
        `${coreapiUrl}/login`,
        payload
      );
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },
  microsoftAuth: async (payload) => {
    try {
      const response = await axios.post(
        `${coreapiUrl}/auth/microsoft-register`,
        payload
      );
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },
  forgetpassword: async (payload) => {
    try {
      const response = await axios.post(
        `${coreapiUrl}/forgetpassword`,
        payload
      );
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },
};
 

export default authService;
